import React from "react";
import '../css/Style.css';
import about from '../img/ai-generated-8127864_640.png';
import mission from '../img/mission_about.jpg';


function About(){
    return(
        <>
         <div className="container-fluid bg-secondary mb-5">
            <div className="container py-3">
            <div class="d-flex justify-content-between ">
              <div className="fw-bold text-white  " >ABOUT US</div>
              <div  className="fw-bold text-white ">Home > About</div>
                </div>
            </div>
         </div>


           <div className="container mb-5 mt-5">
            <div className="row ">
            <div className="col-lg-6 mb-3 p-2 fade-in" >
               <div className="about_title">
               <p className="fw-bold text-start">WELCOME</p>
                <h1 class="display-5 fw-bold bg_text mb-3 text-start">About Us</h1>
                <div class="fancy-border_left"></div>
                <p class="lead text-start  mt-3 text-mute align-middle">
                Welcome to our fruit haven, where freshness meets flavor! Our fruit shop is a burst of color and vitality, offering a handpicked selection of the juiciest, ripest fruits. From sweet berries to tropical delights, every piece is a testament to quality and taste. Our friendly staff is here to guide you through a delightful experience of choosing nature's best. Step into our fruit shop, where health meets happiness in every bite!
                </p>
               </div>
             </div>
             <div className="col-lg-6 mb-3">
             <div className="about_title"> 
                <div class="overflow-hidden" >
                <div class="container">
                    <img src={about}  loading="lazy" className="img-fluid rounded bounce-in-bck  " />
                </div>
             </div>
            </div>
             </div>
             
            </div>
           </div>



           <div className="container mb-5 mt-5">
        <div className="row mb-5">
          <div className="about_title">
            <p className="fw-bold">ABOUT US</p>
            <h3 className="fw-bold bg_text">What We Do</h3>
            <div class="fancy-border"></div>
          </div>
        </div>

        <div className="row">
            <div className="col-lg-4">
           <div className="mb-3">
           <img className="" src="https://preston.axiomthemes.com/wp-content/uploads/2016/10/3.png" class="img-fluid" />
           </div>
            <h3 className="fw-bold bg_text fs-5">Conventional Fruits</h3>
            <div class="fancy-border"></div>
            <p className="text-muted p-2 text-left">Conventional fruit shop: affordable fruits grown with pesticides for accessibility, but with concerns about chemical residues.</p
            >
            </div>
             <div className="col-lg-4">
             <div className="mb-3">
             <img  src="https://preston.axiomthemes.com/wp-content/uploads/2016/10/2.png" class="img-fluid" />
             </div>
            <h3 className="fw-bold bg_text fs-5">Organic Fruits</h3>
            <div class="fancy-border"></div>
            <p className="text-muted p-2 text-left">An organic fruit shop offers eco-friendly fruits grown without synthetic pesticides or fertilizers, though it's often pricier.</p
            >
            </div>
            <div className="col-lg-4">
                <div  className="mb-4">
                <img src="https://preston.axiomthemes.com/wp-content/uploads/2016/10/1.png" class="img-fluid" />
                </div>
             
            <h3 className="fw-bold bg_text fs-5">Our Fresh Fruits</h3>
            <div class="fancy-border"></div>
            <p className="text-muted p-2 text-left">Growing your own fruits at home brings cost savings, reduces waste, and offers the joy of enjoying fresh sustainable hobby.</p
            >
            </div>          
        </div>
       </div>  

    

    <div class="container mt-5 mb-5">
    <div class="row flex-lg-row-reverse align-items-center">
    <div class="col-lg-6 p-2">
        <h1 class="display-5 fw-bold bg_text mb-3 text-start">Our Mission</h1>
        <div class="fancy-border_left"></div>
        <p class="lead  text-start text-muted  mt-4 align-middle ">At Fruit Shop , our mission is to provide you with the freshest, tastiest fruits while supporting local farmers and sustainable practices. We aim to be your trusted source for delicious, seasonal options, creating a welcoming space where you can enjoy the goodness of nature. With a commitment to excellent service and community impact, Fruit Shop is on a mission to bring you freshness and flavor every day."</p>
      </div>
      <div class="col-lg-6">
        <img src={mission}   class=" img-fluid" />
      </div>
      
    </div>
  </div>
        </>
    );
}

export default About;